<template>
  <div class="template-picker">
    <p class="lede">Apply a starting point, then tweak any holiday individually.</p>
    <div class="cards">
      <div v-for="t in templates" :key="t.key" class="card">
        <button
          type="button"
          class="card-main"
          :title="`Apply: ${t.title}`"
          @click="$emit('apply', { key: t.key, reverse: false })"
        >
          <span class="card-title">{{ t.title }}</span>
          <span class="card-desc">{{ t.description }}</span>
        </button>
        <button
          v-if="t.reversible"
          type="button"
          class="card-reverse"
          title="Apply with the parents reversed (start the alternation with the other parent)"
          @click="$emit('apply', { key: t.key, reverse: true })"
        >↔ Reverse parents</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TemplatePicker',
  props: {
    templates: { type: Array, required: true },
  },
}
</script>

<style scoped>
.template-picker {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}
.lede {
  margin: 0;
  font-size: 0.78rem;
  color: #64748b;
}
.cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 0.55rem;
}

/* Each card hosts a primary "Apply" button (the whole card surface) and an
   optional secondary "Reverse" button below it for templates that have a
   starting-parent concept. Non-reversible templates hide the secondary. */
.card {
  display: flex;
  flex-direction: column;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;
}
.card:hover {
  border-color: #3f6772;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}
.card-main {
  text-align: left;
  background: transparent;
  border: none;
  padding: 0.7rem 0.85rem;
  cursor: pointer;
  font-family: inherit;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 100%;
}
.card-title {
  font-weight: 600;
  font-size: 0.85rem;
  color: #34555f;
}
.card-desc {
  font-size: 0.78rem;
  color: #64748b;
  line-height: 1.4;
}
.card-reverse {
  margin: 0;
  background: #fff;
  border: none;
  border-top: 1px dashed #e2e8f0;
  color: #557d89;
  font-family: inherit;
  font-size: 0.74rem;
  font-weight: 500;
  padding: 0.4rem 0.85rem;
  cursor: pointer;
  text-align: left;
  transition: background 0.15s, color 0.15s;
}
.card-reverse:hover {
  background: #eef3f4;
  color: #34555f;
}
</style>
